/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Filter_MoreInputs */

const vi_order_filter_more = /** @type {(inputs: Order_Filter_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lọc thêm`)
};

/**

* @param {Order_Filter_MoreInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_filter_more = /** @type {((inputs?: Order_Filter_MoreInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Filter_MoreInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_filter_more(inputs)
});